export enum HttpEvents {
    BEFORE_SEND_REQUEST = 'http@before-send',
    REQUEST_COMPLETED = 'http@request-completed',
    REQUEST_SUCCESS = 'http@request-succeed',
    REQUEST_FAIL = 'http@request-failed',
}

export type RequestOptions = Omit<RequestInit, 'body'> & {
    body?: BodyInit | null | Record<string, any>,
    json?: Record<string, any>,
}
